import { ReduxStore } from 'store/types';

function resetPasswordIsLoading(state: ReduxStore): boolean {
  return state.auth.resetPassword.config.isLoading;
}

export default resetPasswordIsLoading;
